import Vue from 'vue'
import Vuetify from 'vuetify'
import de from "vuetify/es5/locale/de"
import en from "vuetify/es5/locale/en"
import colors from "vuetify/es5/util/colors"
import '@sportabel/fontawesome/css/all.css'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const options = {
    icons: {
        iconfont: 'fa',
        values: {
            prev: 'far fa-chevron-left',
            next: 'far fa-chevron-right',
            dropdown: 'fas fa-caret-down'
        }
    },
    lang: {
        locales: {de, en},
        current: 'de'
    },
    theme: {
        themes: {
            light: {
                primary: colors.green.darken4,
                secondary: colors.green.darken1
            }
        }
    }
}

export default new Vuetify(options)
